var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mdb-container',[_c('mdb-horizontal-bar-chart',{attrs:{"data":_vm.horizontalBarChartData,"options":_vm.horizontalBarChartOptions,"width":500,"height":320}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }